import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  content: ({ spacing }) => css`
    margin: ${spacing.xs} 0;
  `,

  illustration: ({ spacing }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: ${spacing.xs} 0 ${spacing.sm};
  `,
})

export { useStyles }
